<template>
  <div class="container-fluid py-2">
    <div class="row g-3">
      <div class="col-xl-9 col-lg-8">
        <!-- Modern Sticky Tabs Header -->
        <div class="quota-tabs-card card mb-3 shadow-sm">
          <div class="card-body p-2">
            <el-tabs v-model="tabIndex" class="quota-modern-tabs">
              <el-tab-pane :name="0">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-file-earmark-text me-1"></i> Ərizə</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="3">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-person-badge me-1"></i> Sığorta olunan</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="4">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-shield-check me-1"></i> Şərtlər</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="9">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-exclamation-octagon me-1"></i> İstisnalar</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="7">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-paperclip me-1"></i> Fayllar</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="5">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-clock-history me-1"></i> Versiyalar</span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <!-- Tab contents -->
        <div v-if="tabIndex === 0">
          <Info @toggle-nav="showNavData = !showNavData" @insert="tabIndex = 3; showNavData = !showNavData;"></Info>
        </div>
        <div v-if="tabIndex === 3">
          <Insured @insert="tabIndex = 6"></Insured>
        </div>
        <Conditions v-if="tabIndex == 4"></Conditions>
        <Exceptions v-if="tabIndex == 9"></Exceptions>
        <Files v-if="tabIndex == 7"></Files>
        <Versions v-if="tabIndex == 5"></Versions>
      </div>

      <!-- Right Column: Timeline -->
      <div class="col-xl-3 col-lg-4">
        <Timeline></Timeline>
      </div>
    </div>
  </div>
</template>

<script>
import Info from './Components/Info/Main.vue';
import Conditions from './Components/Conditions/Main.vue';
import Exceptions from './Components/Exceptions/Main.vue';
import Insured from './Components/Insured/Main.vue';
import Files from './Components/Files/Main.vue';
import Versions from './Components/Versions/Main.vue';
import Timeline from './Components/Timeline/Main.vue';

export default {
  name: "QuotaMain",
  components: {
    Info,
    Versions,
    Timeline,
    Files,
    Exceptions,
    Insured,
    Conditions
  },
  data() {
    return {
      showNav: true,
      showNavData: true,
      tabIndex: 0
    };
  }
};
</script>

<style scoped lang="scss">
.quota-tabs-card {
  border: 1px solid var(--app-border, #e2e8f0);
  border-radius: var(--app-radius, 8px);
  background: var(--app-surface, #ffffff);
}

:deep(.quota-modern-tabs) {
  .el-tabs__header {
    margin: 0;
    border-bottom: none;
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__item {
    font-size: 0.85rem;
    font-weight: 650;
    color: var(--app-text, #64748b);
    padding: 0 16px;
    height: 38px;
    line-height: 38px;
    transition: all 0.15s ease;

    &:hover {
      color: var(--bs-info, #0b4f9c);
    }

    &.is-active {
      color: var(--bs-info, #0b4f9c);
      font-weight: 750;
    }
  }

  .el-tabs__active-bar {
    background-color: var(--bs-info, #0b4f9c);
    height: 3px;
    border-radius: 3px;
  }
}

.tab-label-custom {
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
}

[data-theme="dark"] {
  .quota-tabs-card {
    background: #182029;
    border-color: #2e3846;
  }

  :deep(.quota-modern-tabs) {
    .el-tabs__item {
      color: #94a3b8;

      &:hover {
        color: #60a5fa;
      }

      &.is-active {
        color: #93c5fd;
      }
    }

    .el-tabs__active-bar {
      background-color: #60a5fa;
    }
  }
}
</style>